{
  "WantToChat": "¿Quieres hablar?",
  "HelpPhrase": "¡Nosotros también! Escríbenos y avísanos sobre tus problemas, cumplidos o preguntas generales. Nos comunicaremos contigo en un plazo de 24 horas .",
  "TellUs": "¿Cómo podemos ayudarte?",
  "Submit": "Enviar"
}
